<template>
  <div class="recommend_route">
    <div class="title">
      返程推荐 <span>返程推荐路线</span>
    </div>
    <div class="route_info">
      <div class="info_title">车辆返程信息</div>
      <div class="route">
        <div>
          <span>返程路线：</span>
        </div>
        <div>
          <span></span>
          {{fromAddress}}
        </div>
        <div>
          <span></span>
          {{data.destinationDaaress}}
        </div>
        <div>
          <span>车辆当前位置： </span>
          {{data.vehiclePosition}} <p @click="handleShowTrack">查看地图</p>
        </div>
        <div class="showCarInfo"><span @click="showCarInfo=!showCarInfo"
                v-bind:class="showCarInfo?'active':''">车辆信息</span></div>
        <ul class="carInfo"
            v-show="showCarInfo">
          <li><span>公司姓名：</span>{{data.companyName}}</li>
          <li>
            <span>罐体材质：</span>
            <p v-if="data.materialTank==='01'">铝罐</p>
            <p v-else-if="data.materialTank==='02'">铁罐</p>
            <p v-else-if="data.materialTank==='03'">白钢罐</p>
            <p v-else-if="data.materialTank==='04'">铝合金罐</p>
          </li>
          <li><span>设备编码：</span>{{data.equipmentId}}</li>
          <li><span>车头号：</span>{{data.headNumber}}</li>
          <li><span>司机姓名：</span>{{data.driverName}} </li>
          <li><span>备案介质：</span>{{data.mediumClass}} </li>
          <li><span>司机电话：</span>{{data.driverPhone}} </li>
          <li><span>荷载量：</span>{{data.nuclearLoadTonnage}}吨 </li>
          <li>
            <span>车辆状态：</span>
            <p v-if="data.vehicleState==='01'">空车</p>
            <p v-else-if="data.vehicleState==='02'">待运输</p>
            <p v-else-if="data.vehicleState==='03'">重车</p>
          </li>
        </ul>
      </div>
    </div>
    <div class="route_list">
      <div class="route_list_title">
        返程推荐路线
        <div>推荐状态:
          <span v-if="data.schedule === '01'">进行中</span>
          <span v-else-if="data.schedule === '02'">推荐完成</span>
          <span v-else-if="data.schedule === '03'">已取消</span>
        </div>
      </div>
      <div class="list_table">
        <el-table style="width: 100%"
                  :data="routeData"
                  class="order_table">
          <el-table-column fixed
                           label="序号"
                           align="center"
                           type="index"
                           width="50">
          </el-table-column>
          <el-table-column header-align="left"
                           label="返程路线"
                           align="left"
                           min-width="207px">
            <template slot-scope="scope">
              <div class="plan_route">
                <div v-for="item in scope.row.list"
                     :key="item.index">{{item}}
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="操作"
                           header-align="center"
                           align="left"
                           width="190px">
            <template slot-scope="scope">
              <div>
                <el-button @click="handleRouteInfo(data.routeReturnId)">
                  线路详情
                </el-button>
                <el-button @click="handleWaybillRecordClick(data.routeReturnId)">
                  运单记录
                </el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div class="trackMask"
         v-show="track"
         @click="handleCloseMapClick">
    </div>
    <div class="trackContainer"
         v-show="track">
      <div class="track_header">运输轨迹<span class="track_close"
              @click="handleCloseMapClick"></span></div>
      <div class="track_main">
        <div id="track_container"></div>
      </div>
    </div>
  </div>
</template>
<script src="https://webapi.amap.com/maps?v=1.4.13&key=6656a8e9810da0328783e4c374223568"></script>
<script>
import {
  getRecommendDetail
} from 'apis/index'
export default {
  data () {
    return {
      routeReturnId: '',
      fromAddress: {},
      data: {},
      routeData: [],
      showCarInfo: false,
      track: false,
      lnglatInfo: {}
    }
  },
  methods: {
    getData (id) { // 初始化获取数据
      getRecommendDetail({
        routeReturnId: id
      }).then(res => {
        // this.routeData.push({
        //   'list': this.data.list
        // })
        // console.log(this.routeData)

        if (res.data.code === 0) {
          // console.log(res)
          this.fromAddress = res.data.data.address
          this.data = res.data.data.route
          this.lnglatInfo = res.data.data
          this.routeData.push({
            'list': res.data.data.list
          })
        }
      })
    },

    handleRouteInfo (id) { // 线路详情
      this.$router.push({
        path: '/manage/recommend/rodeDetail',
        query: {
          'item': id
        }
      })
    },
    handleWaybillRecordClick (id) { // 运单详情
      this.$router.push({
        path: '/manage/recommend/waybillRecord',
        query: {
          'item': id
        }
      })
    },
    handleShowTrack () { // 展示轨迹
      this.track = true
      let startPoint = [this.lnglatInfo.Blng, this.lnglatInfo.Blat]
      let endPoint = [this.lnglatInfo.ALng, this.lnglatInfo.ALat]
      let trackPoint = [[this.lnglatInfo.alng, this.lnglatInfo.alat], [this.lnglatInfo.blng, this.lnglatInfo.blat]]
      var trackmap = new AMap.Map('track_container', {
        resizeEnable: true,
        center: trackPoint[trackPoint.length - 1],
        zoom: 9
      })
      // console.log(startPoint,endPoint,trackPoint)
      // console.log('ssss',trackPoint[0][0],trackPoint[0][1])
      var track_marker = new AMap.Marker({
        map: trackmap,
        position: trackPoint[0],
        icon: 'http://image.jsh178.com/FmQdHrf-kE2vPHc4AxAH1xHFl0qI',
        offset: new AMap.Pixel(-2, -5),
        autoRotation: true,
        angle: -90
      })
      // var polyline = new AMap.Polyline({
      //   map: trackmap,
      //   path: trackPoint,
      //   showDir:true,
      //   strokeColor: "#28F",  //线颜色
      //   strokeOpacity: 1,     //线透明度
      //   strokeWeight: 6,      //线宽
      //   // strokeStyle: "solid"  //线样式
      // });
      var passedPolyline = new AMap.Polyline({
        map: trackmap,
        path: trackPoint,
        strokeColor: '#28F', // 线颜色
        // strokeOpacity: 1,     //线透明度
        strokeWeight: 6 // 线宽
        // strokeStyle: "solid"  //线样式
      })
      track_marker.moveAlong(trackPoint, 900000)
      var startIcon = new AMap.Icon({
        // 图标尺寸
        size: new AMap.Size(25, 34),
        // 图标的取图地址
        image: '//a.amap.com/jsapi_demos/static/demo-center/icons/dir-marker.png',
        // 图标所用图片大小
        imageSize: new AMap.Size(135, 40),
        // 图标取图偏移量
        imageOffset: new AMap.Pixel(-9, -3)
      })
      // 将 icon 传入 marker
      var startMarker = new AMap.Marker({
        position: startPoint,
        icon: startIcon,
        offset: new AMap.Pixel(-13, -30)
      })
      // 创建一个 icon
      var endIcon = new AMap.Icon({
        size: new AMap.Size(25, 34),
        image: '//a.amap.com/jsapi_demos/static/demo-center/icons/dir-marker.png',
        imageSize: new AMap.Size(135, 40),
        imageOffset: new AMap.Pixel(-95, -3)
      })

      // 将 icon 传入 marker
      var endMarker = new AMap.Marker({
        position: endPoint,
        icon: endIcon,
        offset: new AMap.Pixel(-13, -30)
      })
      trackmap.add([startMarker, endMarker])
    },
    handleCloseMapClick () { // 关闭轨迹
      this.track = false
    }
  },
  mounted () {
    // console.log(this.$route.query.item)
    this.routeReturnId = this.$route.query.item
    this.getData(this.routeReturnId)
  }

}
</script>

<style lang="stylus">
.recommend_route
  overflow-y auto
  .title
    padding-left 20px
    height 50px
    line-height 50px
    font-size 12px
    color #858C96
    background url('../../../../assets/images/01/nav_arrow.png') no-repeat top 21px left 77px #F7F9FB
    span
      color #212832
      margin-left 20px
  .route_info
    width calc(100% - 40px)
    overflow hidden
    background #fff
    margin 0 auto
    .info_title
      height 46px
      line-height 46px
      padding-left 46px
      color #212832
      background url('../../../../assets/images/gaoji_cheliang.png') no-repeat center left 15px
    .route
      padding-top 20px
      overflow hidden
      padding-bottom 10px
      border-bottom 1px solid #CFD5DC
      border-top 1px solid #CFD5DC
      color #212832
      div
        width 100%
        height 40px
        line-height 40px
        p
          display inline-block
          cursor pointer
          color #1B88EE
          margin-left 20px
        span
          width 168px
          text-align right
          display inline-block
          color #5E656F
        &:nth-child(1)
          background url('../../../../assets/images/09/back_line.png') no-repeat center left 83px
        &:nth-child(2)
          background url('../../../../assets/images/begin_icon.png') no-repeat center left 148px
        &:nth-child(3)
          background url('../../../../assets/images/end_icon.png') no-repeat center left 148px
      .showCarInfo
        span
          width 65px
          float right
          margin-right 60px
          text-align left
          color #1B88EE
          cursor pointer
          background url('../../../../assets/images/more_icon_down.png') no-repeat center right
          &.active
            background url('../../../../assets/images/more_icon.png') no-repeat center right
      .carInfo
        border-top 1px dashed #CFD5DC
        padding-top 30px
        overflow hidden
        li
          width 50%
          height 40px
          float left
          list-style none
          span
            width 168px
            display inline-block
            text-align right
            color #5E656F
          p
            display inline-block
  .route_list
    width calc(100% - 40px)
    overflow hidden
    background #fff
    margin 20px auto
    .route_list_title
      width 100%
      height 46px
      line-height 46px
      font-size 12px
      color #212832
      background #fff
      text-indent 2em
      div
        width auto
        background url('../../../../assets/images/09/icon_start.png') no-repeat left center
        float right
        color #5E656F
        margin-right 40px
        span
          color #212832
    .search_range
      width 100%
      height 60px
      .el-select
        float right
        margin 14px 20px 0 0
        .el-input
          width 110px
        .input-with-select .el-input-group__prepend
          background #fff
      label
        float right
        line-height 60px
    .list_table
      .order_table
        th
          background #e7f0f8
          .cell
            size12()
          &:nth-child(2)
            .cell
              padding-left 100px
        td
          size12()
          .plan_route
            float left
            padding-left 90px
            color #5E656F
            position relative
            div
              cursor pointer
              float left
              padding-right 50px
              background url('../../../../assets/images/09/icon_arrow.png') no-repeat center right 20px
              &:nth-last-child(1)
                background none
          .el-button
            padding 6px 14px
            background #1B88EE
            color #fff
            font-size 12px
            border 1px solid #1B88EE
  .trackMask
    position fixed
    top 0
    bottom 0
    left 0
    right 0
    background rgba(0, 0, 0, 0.4)
    z-index 200
  .trackContainer
    width 688px
    z-index 201
    height 446px
    position fixed
    top 50%
    left 50%
    margin-left -344px
    margin-top -223px
    background #fff
    .track_header
      width 100%
      height 42px
      background #1B88EE
      text-indent 1em
      line-height 42px
      font-size 16px
      color #fff
      .track_close
        width 42px
        height 42px
        background url('../../../../assets/images/01/close_icon.png') no-repeat center center
        cursor pointer
        position absolute
        right 0px
        &:hover
          background url('../../../../assets/images/01/tanluang_close.png') no-repeat center center
    .track_main
      width calc(100% - 20px)
      margin 10px auto
      height calc(100% - 62px)
      #track_container
        height 100%
</style>
